import { MatSnackBar } from "@angular/material/snack-bar";

export class DataAlert {
  message: string;
  snackType: string;
  snackBar: MatSnackBar;
}
